<template>
  <tr class="even:bg-white odd:bg-gray-50">
    <td class="px-4 py-4 whitespace-nowrap text-sm font-medium text-gray-900 tabular-nums">
      <div class="flex space-x-4">
        <div class="w-48">
          <div class="aspect-w-16 aspect-h-9" :class="[!cover && 'bg-gray-200 rounded shadow']">
            <img v-if="cover" :src="cover" class="w-full rounded shadow object-cover" />
          </div>
        </div>
        <div class="flex-1">
          {{ project.name }}
        </div>
      </div>
    </td>
    <td class="px-4 py-4 text-right align-top">
      <div class="space-x-2 whitespace-nowrap">
        <ProjectRemoveAction
          :product-id="productId"
          :project="project"
          @project-removed="onProjectRemoved"
        />
      </div>
    </td>
  </tr>
</template>

<script>
import ProjectRemoveAction from './ProjectRemoveAction.vue';

export default {
  components: {
    ProjectRemoveAction,
  },
  props: {
    project: {
      type: Object,
      required: true,
    },
    productId: {
      type: String,
      required: true,
    },
  },
  computed: {
    cover() {
      return this.project?.cover || null;
    },
  },
  methods: {
    onProjectRemoved(removedProject) {
      this.$emit('project-removed', removedProject);
    },
  },
};
</script>
